import { BaseLogger } from "@app/config/loggers/baseLogger";
import { useIsomorphicEffect } from "./useIsomorphicEffect";

/**
 * 이 화면에서 발생하는 이벤트를 특정 현장(프로젝트)에 귀속시킨다.
 *
 * 프로젝트 범위의 화면(상세·작성·편집·작업 이력)에서 호출한다. 화면을 벗어나면
 * 자동으로 해제되므로, 홈이나 로그인 화면의 이벤트에 직전 현장이 따라붙지 않는다.
 *
 * `name` 은 알고 있을 때만 넘긴다 — 그룹 프로필 이름 갱신에만 쓰이고,
 * 없으면 기존 이름을 그대로 둔다.
 *
 * **layout effect 로 거는 이유**: 같은 화면의 다른 훅이 마운트 직후 이벤트를 쏜다
 * (작성 퍼널의 `daily_log_write_start` 등). 일반 effect 로 두면 훅 선언 순서가 앞선 쪽이
 * 먼저 실행돼, 그룹보다 먼저 발행된 이벤트에는 현장이 빠진다. 실제로 작성 라우트에서
 * 시작 이벤트에만 현장이 누락돼 현장별 퍼널의 시작과 완료를 이을 수 없었다.
 * layout effect 는 한 커밋의 모든 일반 effect 보다 먼저 실행되므로 선언 순서와 무관하게
 * 그룹이 먼저 확정된다.
 *
 * 반대로 **언마운트 시점에는 해제가 먼저** 일어난다. 그래서 떠나면서 발행하는 이벤트
 * (이탈 보고 등)는 관측 시작 시점의 현장을 스냅샷해 두었다가 명시적으로 실어 보내야 한다
 * (`captureEventContext`).
 */
export function useProjectAnalyticsGroup(projectId: string, name?: string): void {
  useIsomorphicEffect(() => {
    BaseLogger.setProjectGroup(projectId, name);

    return () => {
      BaseLogger.clearProjectGroup();
    };
  }, [projectId, name]);
}
